import {Component, OnInit, OnDestroy} from '@angular/core';
import {TravelsService, StorageService} from '../../services';


@Component({
  selector: 'app-travels',
  templateUrl: './travels.component.html',
  styleUrls: ['./travels.component.scss']
})
export class TravelsPageComponent implements OnInit {
  travels: any;
  activeTab: number;


  constructor(
    private travelsService: TravelsService,
  ){}

  ngOnInit() {
    this.activeTab = 1;
    // this.getTravels();
   }

  changeTab(index: number, isDisabled?: boolean) {
    if (!isDisabled) {
      this.activeTab = index;
    }
  }

  // private getTravels() {
  //   this.travels = [];
  //   this.travelsService.getTravels({}).subscribe((res) => {
  //     if (res) {
  //       this.travels = res;
  //       console.log('!!!!this.travels', this.travels)
  //     }
  //   }, (err) => {
  //     console.log('!!!!err', err)
  //   });
  //
  // }

}
